import React from 'react';
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom';
import { withRouter } from "react-router";

import { NavigationBar, Egg, ExternalLink } from 'components';
import { Sidebar, Image, List, Popup, Menu, Icon } from 'semantic-ui-react'

import { Auth } from 'services';
import { Env } from 'env';

import { Typeof } from 'utils';

import classnames from 'classnames';

import logo_equisym from 'assets/logos/equisym.png';
import logo_obdo from 'assets/logos/obdo.png'

import './scene.css';

class GenericScene extends React.Component {

  constructor(props) {
    super(props);

    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.handleSidebarHide = this.handleSidebarHide.bind(this);
    this.handleEggs = this.handleEggs.bind(this);
    this.dismissEgg = this.dismissEgg.bind(this);

    this.state = {
      showMenu: true,
      eggs: 0
    };
  }

  toggleSidebar() {

    this.setState({
      showMenu: !this.state.showMenu
    });
  }

  handleSidebarHide() {

    this.setState({
      showMenu: false
    });
  }

  handleEggs()
  {
    let current_eggs = this.state.eggs;
    this.setState({
      eggs: current_eggs + 1,
    })
  }

  dismissEgg()
  {
    this.setState({
      eggs: 0,
    })
  }

  render() {

    if(this.props.headless)
    {
      return this.props.children;
    }

    let user = Auth.getUser();
    const isLogged = Auth.isLogged();

    let routes = [];

    if(isLogged)
    {
      //Manager
      if(Auth.hasRole(Auth.ROLE_MANAGER))
      {
        /* Global  */
        routes.push({
          name: 'Général',
          separator: true
        });

        /* Dashboard */
        routes.push({
          path: '/dashboard',
          name: 'Dashboard'
        });

        /* Clinics */
        routes.push({
          path: '/clinics',
          name: 'Cliniques'
        });

        // /* Users */
        // routes.push({
        //   path: '/users',
        //   name: "Utilisateurs"
        // });

        /* Horses */
        routes.push({
          path: '/horses',
          name: 'Chevaux'
        });

        /* Hardware */
        routes.push({
          name: 'Materiel',
          separator: true
        });

        /* Devices */
        routes.push({
          path: '/devices',
          name: 'Valises'
        });

        /* Sensors */
        routes.push({
          path: '/sensors',
          name: 'Capteurs'
        });

        /* Software */
        routes.push({
          name: 'Logiciel',
          separator: true
        });

        /* Firmwares */
        routes.push({
          path: '/firmwares',
          name: 'Micrologiciel capteur'
        });

        /* Changelog */
        routes.push({
          path: '/changelogs',
          name: "Changelog application"
        });

        /* Invoicing */
        routes.push({
          name: 'Facturation',
          separator: true
        });

        /* Invoices */
        routes.push({
          path: '/invoices',
          name: "Factures"
        });
      }

      //Clinic
      let clinic = Auth.getManagedClinic();

      if(Auth.hasRole(Auth.ROLE_CLINIC) && Typeof.object(clinic))
      {
        /* Software */
        routes.push({
          name: `Clinique «${clinic.name}»`,
          separator: true
        });

        /* Veterinarians */
        routes.push({
          path: '/clinics/users',
          name: 'Vétérinaires'
        });

        /* Horses */
        routes.push({
          path: '/clinics/horses',
          name: 'Chevaux'
        });

         /* Horses */
         routes.push({
          path: '/clinics/invoices',
          name: 'Factures'
        });

      }
    }

    return (

      <React.Fragment>

        <Sidebar.Pushable className={classnames("sidebar-container", { 'navigation': this.props.navigation })}>

          <Sidebar animation='overlay' visible={this.state.showMenu && !this.props.dummy && this.props.navigation}>

            {/* Footer */}
            <div id="header">
              <Image src={logo_equisym} />
            </div>

            {/* Items */}
            <div id="items">

              {/* Navigarion */}
              <Menu fluid vertical pointing secondary>
                {routes.map((route, index) => {

                  if(route.separator) {
                    return (
                      <div className="separator">
                        {route.name}
                      </div>
                    )
                  }

                  let granted = true;

                  if(user != null && Typeof.array(route.roles)) {

                    granted = user.roles.some((role) => {
                      return route.roles.includes(role);
                    });
                  }

                  if(granted) {

                    let isCurrent = this.props.match.url.includes(route.path);

                    return (
                      <Link key={index} to={route.path}>
                        <Menu.Item active={isCurrent}>

                          {/* Icon */}
                          {Typeof.string(route.icon) &&
                            <Icon name={route.icon} />
                          }

                          {/* Name */}
                          {route.name}
                        </Menu.Item>
                      </Link>
                    );
                  }

                  return null;
                })}
              </Menu>
            </div>

            <div id="footer">

              <span id="obdo">
                by
                <ExternalLink target="https://ob-do.com" newTab>
                  <img src={logo_obdo} alt="logo" />
                </ExternalLink>
              </span>

              {/* Build informations */}
              <Popup
                trigger={<span className="version" onClick={this.handleEggs}>{`Version ${Env.BUILD_VERSION}`}</span>} on="hover" position='bottom center'
                content={
                  <List>
                    <List.Item>
                      <List.Icon name='calendar outline' />
                      <List.Content>{Env.BUILD_DATE}</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name='code branch' />
                      <List.Content>{Env.BUILD_HASH}</List.Content>
                    </List.Item>
                  </List>
                }
              />
            </div>

          </Sidebar>

          <Sidebar.Pusher>

            {/* Content */}
            <div id="content" className={classnames({ 'show-navigation': this.props.showNavigation })}>
              <Egg dismissFunction={this.dismissEgg} count={this.state.eggs}></Egg>
              {this.props.children}
            </div>

          </Sidebar.Pusher>

        </Sidebar.Pushable>

        {/* Navigation bar */}
        <NavigationBar onMenuToggle={this.toggleSidebar} />

      </React.Fragment>
    );
  }
}

GenericScene.defaultProps = {
  dummy: false,
  navigation: true
};

GenericScene.propTypes = {
  dummy: PropTypes.bool.isRequired,
  navigation: PropTypes.bool.isRequired
};

export default withRouter(GenericScene);
